import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { FaStar, FaShoppingCart, FaHeart, FaUser, FaHome, FaPhone, FaEnvelope } from 'react-icons/fa';
import { useCart } from '../context/CartContext';

export default function Cart() {
  const { cart, removeFromCart, updateQuantity, getCartTotal } = useCart();
  const navigate = useNavigate();
  const total = getCartTotal();

  const handleCheckout = () => {
    if (cart.length > 0) {
      navigate('/checkout');
    }
  };

  return (
    <div>
      <Helmet>
        <title>Warenkorb - Novurem Patisserie</title>
        <meta name="description" content="Ihr Warenkorb bei Novurem Patisserie." />
      </Helmet>

      <section className="page-header">
        <div className="container">
          <h1>Ihr Warenkorb</h1>
          <p>Überprüfen Sie Ihre Bestellung und fahren Sie mit der Bestellung fort.</p>
        </div>
      </section>

      <section className="cart-section">
        <div className="container">
          {cart.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '60px 20px' }}>
              <div className="success-icon"><FaShoppingCart /></div>
              <h2 style={{ color: '#7b1e3a', fontSize: '28px', marginBottom: '15px' }}>Ihr Warenkorb ist leer</h2>
              <p>Entdecken Sie unsere hauseigenen Spezialitäten und gönnen Sie sich etwas Besonderes.</p>
              <div style={{ marginTop: '20px' }}>
                <Link to="/" className="btn btn-primary"><FaHome /> Zur Startseite</Link>
              </div>
            </div>
          ) : (
            <div className="cart-list">
              <h2 style={{ color: '#7b1e3a', marginBottom: '20px' }}>Ihre Produkte</h2>
              {cart.map((item) => (
                <div key={item.id} className="cart-item">
                  <img src={item.image} alt={item.name} />
                  <div className="cart-item-info">
                    <h3>{item.name}</h3>
                    <p style={{ fontSize: '14px', color: '#666' }}>{item.price.toFixed(2)} € pro Einheit</p>
                    <div className="qty-control">
                      <button className="qty-btn" onClick={() => updateQuantity(item.id, item.quantity - 1)}>-</button>
                      <span>{item.quantity}</span>
                      <button className="qty-btn" onClick={() => updateQuantity(item.id, item.quantity + 1)}>+</button>
                    </div>
                  </div>
                  <div>
                    <p style={{ fontWeight: 'bold', color: '#7b1e3a', fontSize: '18px' }}>{(item.price * item.quantity).toFixed(2)} €</p>
                    <button className="btn btn-ghost btn-sm" onClick={() => removeFromCart(item.id)}>Entfernen</button>
                  </div>
                </div>
              ))}
              <div className="cart-total">
                Gesamtsumme: {total.toFixed(2)} €
              </div>
              <div style={{ display: 'flex', gap: '15px', justifyContent: 'flex-end', marginTop: '20px', flexWrap: 'wrap' }}>
                <Link to="/" className="btn btn-ghost"><FaHome /> Weiter einkaufen</Link>
                <button onClick={handleCheckout} className="btn btn-primary">
                  <FaHeart /> Zur Kasse
                </button>
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}